"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardType = exports.FreemiumRewardFeature = exports.XpChallengeEntity = exports.XpChallengePeriod = exports.XpPeriod = exports.XpEntity = void 0;
var XpEntity;
(function (XpEntity) {
    XpEntity["user"] = "user";
    XpEntity["course"] = "course";
    XpEntity["quiz"] = "quiz";
})(XpEntity = exports.XpEntity || (exports.XpEntity = {}));
var XpPeriod;
(function (XpPeriod) {
    XpPeriod["total"] = "total";
    XpPeriod["yearly"] = "yearly";
    XpPeriod["monthly"] = "monthly";
    XpPeriod["weekly"] = "weekly";
    XpPeriod["daily"] = "daily";
})(XpPeriod = exports.XpPeriod || (exports.XpPeriod = {}));
var XpChallengePeriod;
(function (XpChallengePeriod) {
    XpChallengePeriod["weekly"] = "weekly";
})(XpChallengePeriod = exports.XpChallengePeriod || (exports.XpChallengePeriod = {}));
var XpChallengeEntity;
(function (XpChallengeEntity) {
    XpChallengeEntity["user"] = "user";
    XpChallengeEntity["challenge"] = "challenge";
})(XpChallengeEntity = exports.XpChallengeEntity || (exports.XpChallengeEntity = {}));
var FreemiumRewardFeature;
(function (FreemiumRewardFeature) {
    FreemiumRewardFeature["EXPLAIN_MY_ANSWER"] = "explainMyAnswer";
    FreemiumRewardFeature["EXAM_QUESTION"] = "examQuestion";
    FreemiumRewardFeature["WRONG_ANSWERS"] = "wrongAnswers";
    FreemiumRewardFeature["HARDEST_QUESTIONS"] = "hardestQuestions";
})(FreemiumRewardFeature = exports.FreemiumRewardFeature || (exports.FreemiumRewardFeature = {}));
var RewardType;
(function (RewardType) {
    RewardType["AVATAR"] = "avatar";
    RewardType["FREEMIUM"] = "freemium";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
//# sourceMappingURL=index.js.map